module.exports = __webpack_public_path__ + "static/media/scrolldown.e068eabc.svg";